export default {
  name: 'dashify:List',
  title: 'List',
  owner: 'System',
  solution: '',
  tags: ['html', 'list'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [
      [
        'dashify:UL',
        {},
        [
          ['dashify:LI', {}, 'Task 1'],
          ['dashify:LI', { '.': 'text-red-500' }, 'Task 2'],
          ['dashify:LI', {}, 'Task 3'],
        ],
      ],
    ],
  },
};
